<template>
	<div class="input-group">
		<input
			type="number"
			v-model="val"
			class="form-control"
			:disabled="disabled != undefined ? disabled : false"
		/>
		<div class="input-group-btn">
			<button
				type="button"
				class="btn btn-default dropdown-toggle"
				data-toggle="dropdown"
			>
				{{ type }}
				<span class="caret"></span>
			</button>
			<ul class="dropdown-menu">
				<li @click="selected_type('Dia(s)')"><a>Dia(s)</a></li>
				<li @click="selected_type('Hor(s)')"><a>Hor(s)</a></li>
				<li @click="selected_type('Min(s)')"><a>Min(s)</a></li>
			</ul>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'AppTimePuBLIC',
		props: ['value', 'disabled'],
		data() {
			return {
				type: 'Dia(s)',
			};
		},
		computed: {
			val: {
				get() {
					if (this.type == 'Dia(s)')
						return parseInt(this.value / 24 / 60);
					if (this.type == 'Hor(s)') return parseInt(this.value / 60);
					if (this.type == 'Min(s)') return parseInt(this.value);
				},
				set(val) {
					if (val != '') {
						if (this.type == 'Dia(s)')
							this.$emit('input', parseInt(val * 24 * 60));
						if (this.type == 'Hor(s)')
							this.$emit('input', parseInt(val * 60));
						if (this.type == 'Min(s)')
							this.$emit('input', parseInt(val));
					}
				},
			},
		},
		methods: {
			selected_type(type) {
				this.type = type;
			},
		},
	};
</script>
<style scoped>
	.dropdown-menu li a {
		cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// src/app-components/time.vue